<div class="table-width">
  @if (accessGroups().length && !showForm) {
    <table #accessGroupList [dataSource]="accessGroups()" mat-table>
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Navn</th>
        <td mat-cell *matCellDef="let accessGroup" class="row">{{ accessGroup.name }}</td>
      </ng-container>
      <ng-container matColumnDef="amount">
        <th mat-header-cell *matHeaderCellDef>Rabat</th>
        <td mat-cell *matCellDef="let accessGroup" class="row">
          {{ accessGroup.amount }} {{ discountUnit }}
          @if (accessGroup.sharedDiscountId) {
            <mat-icon
              svgIcon="icon_transverse_discount"
              class="shared-discount-icon"
              matTooltip="Tværgående rabat: {{ accessGroup.sharedDiscountName }}"></mat-icon>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="carType">
        <th mat-header-cell *matHeaderCellDef>Biltype</th>
        <td mat-cell *matCellDef="let accessGroup" class="row">
          {{ accessGroup.carType | translateAccessGroupCarTypeEnum }}
        </td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let accessGroup">
          <div class="flex">
            <button
              mat-icon-button
              class="margin--left-auto"
              title="Adgangsbegrænsninger for adgangsgruppe"
              (click)="limitAccessGroupAccess(accessGroup)"
              [matBadge]="accessGroup.accessCount ?? 0"
              [matBadgeHidden]="!accessGroup.accessCount"
              matBadgeColor="primary"
              matBadgeSize="large"
              [admRequiresFeatureRole]="roles['access-group.write']">
              <mat-icon>security</mat-icon>
            </button>
            <button
              mat-icon-button
              title="Rediger adgangsgruppe"
              (click)="editAccessGroup(accessGroup)"
              [admRequiresFeatureRole]="roles['access-group.write']">
              <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#edit-s"></use></svg>
            </button>
            <button
              mat-icon-button
              class="delete"
              title="Slet adgangsgruppe"
              (click)="deleteAccessGroup(accessGroup)"
              [admRequiresFeatureRole]="roles['access-group.write']">
              <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#trash-s"></use></svg>
            </button>
          </div>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
      <tr mat-row *matRowDef="let department; columns: displayColumns"></tr>
    </table>
  }

  @if (showForm) {
    <adm-step3-access-groups-form
      (emitCancel)="handleCancelForm()"
      (save)="handleSave($event)"
      [accessGroup]="accessGroupBeingEdited ?? undefined"
      [discountType]="discountType"></adm-step3-access-groups-form>
  }
  <div class="flex gap-16 margin--top-l">
    @if (!showForm && !hasCreatedStandardAccessGroups) {
      <button
        mat-raised-button
        color="secondary"
        (click)="createStandardAccessGroups()"
        [disabled]="createStandardAccessGroupsButtonDisabled"
        [admRequiresFeatureRole]="roles['default-access-group.write']">
        <mat-icon>filter_3</mat-icon>
        Opret standard adgangsgrupper
      </button>
    }

    @if (!showForm) {
      <button
        [admRequiresFeatureRole]="roles['access-group.write']"
        mat-button
        data-pw="go-to-create-access-group"
        (click)="handleShowForm()">
        <svg class="icon-20"><use href="assets/images/ok-icons-sprite.svg#plus-s"></use></svg>
        {{ hasCreatedStandardAccessGroups ? 'Opret ekstra adgangsgruppe' : 'Opret adgangsgruppe' }}
      </button>
    }
  </div>
</div>
<button mat-raised-button color="primary" class="margin--top-xl" (click)="handleSkipToNextStep()">
  {{ priceRegulationsEnabled() ? 'Opret prisregulering' : 'Tilknyt moduler' }}
</button>
